const BASE_URL = 'https://www.zhaowaixie.com'
export default BASE_URL